import { toast } from "sonner";
import { Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/i18n";
import { burnSecret, translateApiError } from "@/lib/api";

export default function BurnZone({ id, onBurned }) {
  const { t } = useLang();

  const handleBurn = async () => {
    try {
      await burnSecret(id);
      onBurned();
      toast.success(t("burned"));
    } catch (e) {
      toast.error(translateApiError(t, e));
    }
  };

  return (
    <div className="p-6 md:p-8">
      <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-[#ff3b30] mb-4">
        <Flame className="w-3.5 h-3.5" /> danger zone
      </div>
      <p className="text-xs text-neutral-500 mb-4 leading-relaxed">
        {t("burnWarning")}
      </p>
      <Button
        data-testid="burn-now-button"
        onClick={handleBurn}
        className="rounded-none bg-transparent border border-[#ff3b30] text-[#ff3b30] hover:bg-[#ff3b30] hover:text-white dark:hover:text-black font-bold uppercase tracking-widest text-xs"
      >
        <Flame className="w-4 h-4 mr-2" /> {t("burnNow")}
      </Button>
    </div>
  );
}
